import { HighlightedFeedbackText } from '@modules/feedback/components/FeedbackHighlighter/HighlightedFeedbackText';
import { trackCopyFeedbackContentEvents } from '@modules/feedback/utils/trackCopyFeedbackContentEvents';
import { Typography } from '@mui/material';
import { Box } from '@mui/system';
import { Feedback } from 'v2/core/entities/feedback';
import { FeedbackContentReview } from 'v2/core/entities/feedback/content';

interface ReviewTypeProps {
  feedback: Feedback;
  highlights: any;
  showOriginalLanguage: boolean;
}

export const ReviewType = ({
  feedback,
  highlights,
  showOriginalLanguage,
}: ReviewTypeProps) => {
  const content = showOriginalLanguage
    ? (feedback.content as FeedbackContentReview)?.textOriginal || ''
    : (feedback.content as FeedbackContentReview)?.textEn;

  return (
    <Box
      sx={{
        padding: 3,
        borderRadius: 2,
        width: '100%',
        backgroundColor: 'feedback.chatBubble.primary',
      }}
      onCopy={() => {
        trackCopyFeedbackContentEvents({
          eventName: 'Copied Text From Feedback Content',
          feedbackID: feedback.id,
          feedbackType: feedback.content.type,
          contentType: 'raw',
        });
      }}
    >
      <Typography
        variant="body1"
        sx={{
          wordBreak: 'break-word',
          whiteSpace: 'pre-line',
        }}
      >
        <HighlightedFeedbackText
          text={content}
          highlights={highlights[0]}
          showOriginalLanguage={showOriginalLanguage}
        />
      </Typography>
    </Box>
  );
};
